import { createShadow } from 'swiper/effect-utils';
import { effectInit } from 'swiper/effect-utils';
import { effectTarget } from 'swiper/effect-utils';

function getRotateFix(swiper) {
  return (v) => {
    if (
      Math.abs(v) > 0 &&
      swiper.browser &&
      swiper.browser.need3dFix &&
      Math.abs(v) % 90 === 0
    ) {
      return v + 0.001;
    }
    return v;
  };
}

function getSlideTransformEl(slideEl) {
  return (
    slideEl.querySelector('.swiper-slide-transform') ||
    (slideEl.shadowRoot &&
      slideEl.shadowRoot.querySelector('.swiper-slide-transform')) ||
    slideEl
  );
}

export function EffectCoverflow({ swiper, extendParams, on }) {
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
    },
  });

  const setTranslate = () => {
    const {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid,
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const transform = swiper.translate;
    const center = -transform + swiperWidth / 2;
    const swiperLeft = -transform;
    const rotate = params.rotate;
    const translate = params.depth;
    const r = getRotateFix(swiper);

    // Each slide offset from center
    for (let i = 0, length = slides.length; i < length; i += 1) {
      const slideEl = slides[i];
      const slideSize = slidesSizesGrid[i];
      const slideOffset = slideEl.swiperSlideOffset;
      const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
      const offsetFromLeft = (slideOffset - swiperLeft) / slideSize;
      const offsetMultiplier =
        typeof params.modifier === 'function'
          ? params.modifier(offsetFromLeft)
          : offsetFromLeft * params.modifier;
      // const offsetMultiplier =
      //   typeof params.modifier === 'function'
      //     ? params.modifier(centerOffset)
      //     : centerOffset * params.modifier;

      let rotateY = rotate;
      let rotateX = 0;
      // var rotateZ = 0
      let translateZ = -translate * Math.abs(offsetMultiplier);

      // slideEl.style.opacity = Math.abs(offsetMultiplier);
      // console.log(Math.abs(offsetMultiplier));

      let stretch = params.stretch;
      // Allow percentage to make a relative stretch for responsive sliders
      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = (parseFloat(params.stretch) / 100) * slideSize;
      }
      let translateY = 0;
      let translateX = stretch * offsetMultiplier;

      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);

      // Fix for ultra small values
      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;

      let absOffset = Math.abs(offsetMultiplier);
      let opacity = 1;
      if (absOffset <= 0.3) {
        opacity = 1;
      } else if (absOffset >= 1.7) {
        opacity = 0;
      } else {
        // Linear interpolation between 1 and 0 in [0.3, 1.7]
        opacity = 1 - (absOffset - 0.3) / (1.7 - 0.3);
      }

      // slideEl.style.opacity = opacity;

      let maxBlur = 10; // maximum blur in pixels
      let blur = 0;

      if (absOffset <= 0.3) {
        blur = 0;
      } else if (absOffset >= 1.7) {
        blur = maxBlur;
      } else {
        // Linear interpolation between 0 and maxBlur
        blur = ((absOffset - 0.3) / (1.7 - 0.3)) * maxBlur;
      }
      slideEl.style.setProperty('--slide-blur', `${blur}px`);
      slideEl.style.setProperty('--slide-opacity', `${opacity}`);

      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(
        rotateX,
      )}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = slideTransform;

      slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
    }
  };
  const setTransition = (duration) => {
    const transformElements = swiper.slides.map((slideEl) =>
      getSlideTransformEl(slideEl),
    );

    transformElements.forEach((el) => {
      el.style.transitionDuration = `${duration}ms`;
    });
  };

  effectInit({
    effect: 'coverflow',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true,
    }),
  });
}
